import Backoffice from "@snark/backoffice";


let crud = {
    name: "discount",
    collection: "discount",
    idProperty: "_id",
    section: "Commercial",
    labels: {
        "listTitle": "Codes Promo",
        "singleTitle": "Code Promo"
    },
    pagination: 50,
    backTextFilterList: true,
    sort: {back: [{field: "createdAt", order: "desc"}]},
    emptyItem: {
        type: "percent",
        amount: 0,
        used: false
    },
    listColumns: [
	    {
		    name: "code",
		    label: "Code"
	    },
	    {
		    "name": "type",
		    "label": "Type",
		    formatter: Backoffice.formatters.mapping({
			    percent: "Pourcentage",
		    })
	    },
	    {
		    name: "amount",
		    label: "Montant",
		    formatter: Backoffice.formatters.number(2, "%"),
	    },
	    {
			name: "email",
		    label: "Email"
		},
	    {
		    name: "used",
		    label: "Utilisé",
		    formatter: Backoffice.formatters.boolean(["Non", "Oui"])
	    },
    ],
    fields: [
        {
            "name": "_id",
            "label": "Identifiant",
            "readOnly": true,
            "hideOnCreate": true
        },
        {
            "name": "code",
            "label": "Code"
        },
        {
            "name": "type",
            "label": "Type",
	        formatter: Backoffice.formatters.mapping({
		        percent: "Pourcentage"
	        }),
	        editor: {
		        "type": "select",
		        "options": [
			        {value: "percent", label: "Pourcentage"}
		        ]
	        }
        },
        {
            "name": "amount",
            "label": "Montant",
	        formatter: Backoffice.formatters.number(2, "%"),
	        editor: {
		        type: "integer",
		        min: 0,
		        max: 100
	        }
        },
        {
            "name": "email",
            "label": "Email"
        },
        {
            "name": "used",
            "label": "Utilisé",
	        formatter: Backoffice.formatters.boolean(["Non", "Oui"]),
	        editor: {type: "boolean", labels: ["Non", "Oui"]},
        },
        {
            "name": "createdAt",
            "label": "Créé le",
            "formatter": Backoffice.formatters.date("DD/MM/YYYY"),
            "readOnly": true,
            "hideOnCreate": true
        }
    ],
};
export default crud;
